import rb from "../../static/cap.png";

export function RetornoDaListagemVazia() {
  return (
    <div className="mx-auto flex max-w-[420px] flex-col items-center justify-center py-8 text-center">
      <img
        src={rb}
        alt="GWR"
        loading="lazy"
        className="w-[300px] max-w-full object-contain"
      />
      <p className="text-lg font-medium text-slate-700 dark:text-slate-200">
        Ainda não há dados disponíveis ):
      </p>
    </div>
  );
}

